/**
 * Enhanced BookingDatesForm with Availability Calendar Integration
 * Wraps the existing BookingDatesForm to add availability checking
 */

import React from 'react';
import ListingCalendar from '../../ListingCalendar/ListingCalendar';
import BookingDatesForm from './BookingDatesForm';

const BookingDatesFormWithAvailability = (props) => {
  const { listing, author, ...restProps } = props;
  
  // Extract provider ID from listing or author
  const providerId = author?.id?.uuid || 
                    listing?.relationships?.author?.data?.id?.uuid ||
                    listing?.authorId;

  if (!providerId) {
    console.warn('⚠️ No provider ID found for availability calendar');
    // Fall back to regular form without availability calendar
    return <BookingDatesForm {...props} />;
  }

  return (
    <ListingCalendar providerId={providerId}>
      {({ disabledDates, minDate, loading, error, enabled }) => {
        // Enhanced props to pass to BookingDatesForm
        const enhancedProps = {
          ...restProps,
          listing,
          author,
          // Add availability data to the form
          availabilityCalendar: {
            enabled,
            disabledDates,
            minDate,
            loading,
            error
          }
        };

        return <BookingDatesForm {...enhancedProps} />;
      }}
    </ListingCalendar>
  );
};

export default BookingDatesFormWithAvailability;
